import { useQuery } from '@tanstack/react-query';
import { getAuthAccess } from 'src/api/queries';

const useAuthAccessQuery = ({
  relation,
  entityId,
  entityType
}: {
  relation: string;
  entityType: string;
  entityId: string;
}) => {
  const { data: isAllowed, isLoading } = useQuery({
    queryKey: [
      'auth-access',
      {
        relation,
        entityId,
        entityType
      }
    ],
    queryFn: () => {
      return entityId
        ? getAuthAccess({
            relation,
            entityType,
            entityId
          })
        : null;
    },
    retry: 0
  });

  return { isAllowed, isLoading };
};

export default useAuthAccessQuery;
